import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const SectionContainer = styled(motion.section)`
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  position: relative;
  overflow: ${props => props.overflow || 'hidden'};
`;

const Section = ({ children, background = 'transparent', disableFade = false, ...props }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  return (
    <SectionContainer
      ref={ref}
      initial={disableFade ? { opacity: 1 } : { opacity: 0 }}
      animate={{ 
        opacity: disableFade ? 1 : (inView ? 1 : 0.8),
      }}
      transition={disableFade ? { duration: 0 } : { duration: 0.5 }}
      style={{ background }}
      {...props}
    >
      {children}
    </SectionContainer>
  );
};

export default Section;